<nav
  class="fixed left-0 right-0 top-0 z-50 flex h-[72px] items-center justify-between border-b bg-background-primary text-white"
>
  <div
    [ngClass]="[menuService.showSideBar ? 'md:w-[280px]' : 'md:w-20']"
    class="relative flex h-full flex-row items-center justify-between transition-all duration-500 md:border-r"
  >
    <app-logo class="pl-5" />
    <!-- Toggle do menu na divisória: chevron aponta ◀ (recolher) / ▶ (expandir) -->
    <button
      (click)="toggleSidebar()"
      type="button"
      class="absolute right-0 top-1/2 z-50 hidden h-6 w-6 -translate-y-1/2 translate-x-1/2 items-center justify-center rounded-full border border-gray-200 bg-background text-content-tertiary shadow-sm transition-colors hover:bg-gray-200/60 hover:text-content-secondary md:flex"
      [attr.aria-label]="menuService.showSideBar ? 'Recolher menu' : 'Expandir menu'"
    >
      <app-icon [name]="menuService.showSideBar ? 'chevron_left' : 'chevron_right'" size="0.9em" />
    </button>
  </div>

  <div class="sm:order-4 md:flex md:flex-1 lg:w-0">
    <div class="mx-auto flex w-full max-w-[1536px] items-center gap-2 px-4 md:px-8">
      <div class="flex flex-row gap-2">
        <app-tenant-logado-navbar class="mr-auto hidden md:flex" />

        <!-- Empresa visível no mobile: logo compacta com wrapper claro para legibilidade no fundo escuro -->
        @if (usuarioLogado$ | async; as usuario) {
          <button
            type="button"
            appButton
            (click)="abrirTrocaTenant()"
            class="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 bg-transparent p-1 transition-colors hover:bg-gray-200/60 md:hidden"
            variant="link"
            [attr.aria-label]="'Empresa: ' + usuario.tenant"
          >
            <app-logo-empresa
              tamanho="sm"
              daEmpresaAtual
              [nome]="usuario.tenant"
              [logoAnexoId]="usuario.logoAnexoId"
              [logoUrl]="usuario.logoUrl"
            />
          </button>
        }
      </div>

      <div class="ml-auto flex flex-row gap-2">
        <app-dropdown class="right-0 hidden origin-top-right md:flex">
          <button
            asTrigger
            appButton
            class="relative flex h-10 w-10 min-w-0 items-center justify-center rounded-lg border border-gray-200 bg-transparent text-content-secondary transition-colors hover:bg-gray-200/60"
            variant="link"
          >
            @if ((unreadCount$ | async) ?? 0 > 0) {
              <div
                class="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white shadow-sm"
              >
                {{ unreadCount$ | async }}
              </div>
            }
            <app-icon class="flex items-center justify-center text-content-secondary" name="notifications" />
          </button>
          <app-notification-list />
        </app-dropdown>

        <app-usuario-logado-navbar class="hidden md:flex" />

        <button
          (click)="toggleMobileMenu()"
          appButton
          class="flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 bg-white text-content-secondary transition-colors duration-200 hover:bg-gray-50 focus:outline-none md:hidden"
          variant="link"
        >
          <app-icon class="flex items-center justify-center text-content-secondary" name="menu" />
        </button>
      </div>
    </div>
  </div>
</nav>
